/* eslint-disable camelcase */
export enum OwnershipLevelType {
  Main = 'MAIN',
  Additional = 'ADDITIONAL',
}

export enum OwnershipLevel {
  MAIN = 'Titular',
  ADDITIONAL = 'Adicional',
}

export enum CardType {
  Virtual = 'VIRTUAL',
  Physical = 'PHYSICAL',
}

export enum CardState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export enum CardBalanceType {
  CENTRALIZED = "CENTRALIZED",
  DECENTRALIZED = "DECENTRALIZED"
}

export enum CardBalanceTypeParser {
  CENTRALIZED = "CENTRALIZADO",
  DECENTRALIZED = "DESCENTRALIZADO"
}

export interface ICard {
  id: string;
  card_id: string;
  card_holder_id: string;
  card_product_id: string;
  created_time: string;
  last_modified: string;
  card_type: string;
  sequence_number: string;
  additional_number: string;
  state: string;
  state_reason: string;
  last_four: string;
  cardholder_parent: string;
  card_parent: string;
  ownership_level: string;
}
